module.exports = __webpack_public_path__ + "img/2025_LongSleeve.015ea4dd.jpg";